/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
export enum RouteCodes {
  welcome = 'WELCOME',
  summary = 'SUMMARY',
  finish = 'FINISH',
  quotation = 'QUOTATION',
  obligations = 'OBLIGATIONS',
  resolution = 'RESOLUTION',
  recognition = 'RECOGNITION',
  consents = 'CONSENTS',
  documentsRequest = 'DOCUMENTS-REQUEST',
  documentsView = 'DOCUMENTS-VIEW',
  adequacy = 'ADEGUACY',
  contractSigning = 'CONTRACT-SIGNING',
  notes = 'NOTES'
}
